import { GetAllTopicResponse, TopicLite, TopicRequest } from "interfaces";
import axiosInstance from "utils/AxiosInterceptor";

export const addNewTopic = async (payload: TopicRequest) => {
  return axiosInstance.post("api/topic/add", payload);
};

export const updateTopic = async (payload: TopicRequest) => {
  return axiosInstance.put("api/topic/update", payload);
};

export const deleteTopic = async (topicId: string) => {
  return axiosInstance.delete(`api/topic/delete?topicId=${topicId}`);
};

export const getTopicListLite = async () => {
  return axiosInstance.get<TopicLite[]>("api/topic/get-topics-list");
};

export const getAllTopics = async (...args: any) => {
  let url = `api/topic/get-topics?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });
  return axiosInstance.get<GetAllTopicResponse>(url);
};
